import { QueryClient } from '@tanstack/vue-query'

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      retry: false,
    },

    mutations: {
      retry: false,
    },
  },
})

// @ts-expect-error TanStack debug
window.__TANSTACK_QUERY_CLIENT__ = queryClient
